import { DateFormatter } from 'src/utils/dateformat';
import React from 'react';

interface DateTimeTplProps {
  value: Date;
}

const DateTimeTpl: React.FC<DateTimeTplProps> = ({ value }) => <div>{DateFormatter(value)}</div>;

export default DateTimeTpl;
